import Cookie from '../helpers/Cookie';

;$(function() {

    function show(type) {
        $('.sorting__select_' + type).children('.sorting__options').slideDown();
        active[type] = true;
    }
    function hide(type) {
        $('.sorting__select_' + type).children('.sorting__options').slideUp();
        active[type] = false;
    }

    var active = {
        type: false,
        ammount: false
    };

    $(document).click(function(e) {
        if (! active.type && ! active.ammount)
            return;

        if (! $(e.target).parents('.sorting__item').length)
            return hide(active.type ? 'type' : 'ammount');

        var check = $(e.target).parents('.sorting__item').find('.sorting__select').hasClass('sorting__select_ammount') ? 'type' : 'ammount';
        if (active[check])
            hide(check);
    });

    $('.sorting__select-caption').click(function() {
        var type = $(this).parents('.sorting__select').hasClass('sorting__select_ammount') ? 'ammount' : 'type';

        if ($(this).next().css('display') == 'none') {
            show(type);
        }
        else {
            hide(type);
        }
    });

    $('.sorting__select_ammount').on('click', '.sorting__option-item', function() {
        Cookie.set('lot_ammount', $(this).text(), {expires: 60 * 60 * 24 * 7});
        window.location.href = window.location.href;
    });

});